export const MtmKpiValueQueryKey = 'es-mtm-kpi-value'
export const HistoricalMtmQueryKey = 'historical-kpi-mtm-value'
export const YearlyKpiValueQueryKey = 'es-yearly-kpi-value'
export const CommentsQueryKey = 'comment-kpi-mtm-value'
export const ExcelExportQueryKey = 'expert-system-excel-export'
export const HistoricalMtmKpiValueQueryKey = 'historical-kpi-mtm-value'
export const ReadableRootsQueryKey = 'expert-system-readable-roots'
export const KpiSearchQueryKey = 'expert-system-kpi-search'
export const DailyKpiValuesQueryKey = 'es-daily-kpi-values'
export const MonthlyKpiValuesQueryKey = 'es-monthly-kpi-values'
